import { injectFeatureReducer } from '@/platform/state/reducerRegistry'
import { taxonomiesReducer } from './taxonomiesSlice'

export function registerTaxonomiesStore(): void {
  injectFeatureReducer('taxonomies', taxonomiesReducer)
}
